var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { Calendar, } from '@progress/kendo-react-dateinputs';
import { Popover } from '../Popover';
import { Icon } from '../Icon';
import { keys } from '../../utilities/keyCodes';
import { InputDateMask } from './InputDateMask';
export const DatePicker = React.forwardRef((props, ref) => {
    const { disabled, error, maskChar, maskProps, maxDate, minDate, onChange, placeholder, size, value, calendar: CustomCalendar, direction = 'br', open } = props, rest = __rest(props, ["disabled", "error", "maskChar", "maskProps", "maxDate", "minDate", "onChange", "placeholder", "size", "value", "calendar", "direction", "open"]);
    const calendarRef = React.useRef(null);
    const inputRef = React.useRef(null);
    const [showCalendar, setShowCalendar] = React.useState(open);
    const [focusCalendar, setFocusCalendar] = React.useState(false);
    // Keeping this incase we need to also pass calendar to ref
    /**
     * React.useImperativeHandle(ref, () => ({
     * input: inputRef.current,
     * calendar: calendarRef.current,
     * }));
     */
    const handleClickOutside = () => {
        if (showCalendar) {
            setShowCalendar(false);
            inputRef.current.focus();
        }
    };
    const handleClickIcon = () => setShowCalendar(!showCalendar);
    const handleInputClick = (event) => {
        event.preventDefault();
        setShowCalendar(true);
        inputRef.current.focus();
    };
    const handleKeyDown = (event) => {
        const { key } = event;
        if (key === keys.esc) {
            event.preventDefault();
            setShowCalendar(false);
            inputRef.current.focus();
        }
        if ([keys.space, keys.down].includes(key)) {
            event.preventDefault();
            setShowCalendar(true);
            setFocusCalendar(true);
        }
        if (showCalendar && key === keys.tab) {
            setShowCalendar(false);
        }
    };
    React.useEffect(() => {
        var _a;
        if (focusCalendar) {
            (_a = calendarRef === null || calendarRef === void 0 ? void 0 : calendarRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            setFocusCalendar(false);
        }
    }, [focusCalendar]);
    React.useEffect(() => {
        setShowCalendar(open);
    }, [open]);
    const handleChange = (event) => {
        const eventValue = event.target.value;
        const value = eventValue ? eventValue : undefined;
        onChange(value);
        setShowCalendar(false);
        inputRef.current.focus();
    };
    const DatePickerClasses = classnames('DatePicker', {
        'DatePicker--disabled': disabled,
        [`DatePicker--${size}`]: size,
    });
    const InputProps = Object.assign({ disabled,
        error,
        maskChar,
        maxDate,
        minDate,
        onChange,
        placeholder,
        size,
        value }, maskProps);
    const CalendarProps = {
        value,
        max: maxDate,
        min: minDate,
        onChange: handleChange,
        ref: calendarRef,
        tabIndex: -1,
    };
    return (React.createElement(Popover, Object.assign({ portal: true, wrapperClassName: DatePickerClasses, open: showCalendar, popoverContentClassName: "DatePicker__calendar", onKeyDown: handleKeyDown, direction: direction, padding: null, width: "auto", ref: ref, onClickOutside: () => handleClickOutside(), trigger: React.createElement(InputDateMask, Object.assign({}, InputProps, { inputRef: inputRef, className: "DatePicker__input", onClick: handleInputClick, shortLabel: React.createElement(Icon, { name: "event", className: "DatePicker__icon", onClick: handleClickIcon }), fluid: true })) }, rest), CustomCalendar ? (React.createElement(CustomCalendar, Object.assign({}, CalendarProps))) : (React.createElement(Calendar, Object.assign({}, CalendarProps)))));
});
//# sourceMappingURL=DatePicker.js.map